/**
 * 客户画像留资接口
 */

import { createApiClient } from './client';
import { handleApiResponse } from '@/lib/utils/api-response-handler';
import { logger } from '@/lib/logger';

// --- Types ---

export type CustomerProfileService =
  | "创意内容制作"
  | "品牌整合营销：国内"
  | "品牌整合营销：出海"
  | "GEO（AI搜索优化）"
  | "AI+营销定制化产品"
  | "OranAI产品技术服务"
  | "其他";

export type CustomerProfileBudget =
  | "0~5w"
  | "5~10w"
  | "10~20w"
  | "20~50w"
  | "50w~";

export type CustomerProfileLanguage = "zh-CN" | "en-US";

export interface CustomerProfileSubmissionReq {
  name: string;
  language?: CustomerProfileLanguage;
  company: string;
  position: string;
  industry?: string;
  country: string;
  phone?: string;
  email?: string;
  services: CustomerProfileService[];
  otherServiceRemark?: string;
  budget: CustomerProfileBudget;
}

export type FeishuSyncStatus = "PENDING" | "SUCCESS" | "FAILED";

export interface CustomerProfileSubmissionResp {
  id: number;
  submissionNo: string;
  duplicate: boolean;
  feishuSyncStatus: FeishuSyncStatus;
  feishuRecordId?: string | null;
}

// --- API Client ---

const appApiClient = createApiClient(import.meta.env.NEXT_PUBLIC_API_BASE_URL || "");

// --- API Functions ---

/**
 * 提交客户画像留资表单
 * @param data 表单数据
 * @returns 提交结果
 */
export async function submitCustomerProfile(
  data: CustomerProfileSubmissionReq
): Promise<CustomerProfileSubmissionResp> {
  try {
    const response = await appApiClient.post<CustomerProfileSubmissionResp>(
      '/api/app/customer-profile/submissions',
      data,
      {
        needAuth: false,
      }
    );

    const result = handleApiResponse(response, '提交失败');

    logger.info('Customer profile submitted successfully', {
      id: result.id,
      submissionNo: result.submissionNo,
      duplicate: result.duplicate,
    });

    return result;
  } catch (error) {
    logger.error('Failed to submit customer profile', error as Error);
    throw error;
  }
}